import { ImageBackground } from 'react-native';

export default ImageBackground;
